import React, { useState } from 'react';
import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import { FaArrowLeft, FaPencilAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { useFirestore } from '../../../hooks/useFirestore';
import { useAlert } from '../../../contexts/alerta';
import InputFile from '../../../components/inputFile';
import { FaXmark } from 'react-icons/fa6';
import { mensagemNovoRelato } from '../../../hooks/useEmail';

export default function NewEn(params) {
  const [showForm, setShowForm] = useState(false)
  const [showUserForm, setShowUserForm] = useState(false)
  const [showAnonForm, setShowAnonForm] = useState(false)
  const [form, setForm] = useState({
    nome: '',
    email: '',
    telefone: '',
    motivo: '',
    relato: '',
    protocolo: '',
  })
  const [anexos, setAnexos] = useState([])

  const { novoRelato } = useFirestore()
  const nav = useNavigate();
  const { addAlert } = useAlert()

  const handleShowForm = () => {
    setShowForm(true)
    setShowAnonForm(true)
    setShowUserForm(false)
  }

  const handleUserForm = () => {
    setShowUserForm(true)
    setShowAnonForm(false)
    setShowForm(true)
  }

  const handleChangeInput = (value, type) => {
    setForm({ ...form, [type]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    form.anexos = anexos

    novoRelato(form)
      .then(res => {
        mensagemNovoRelato({ idRelato: res.uuid })
        nav('/en/sucess', { state: { relato: res } })
      })
      .catch((e) => {
        addAlert('An unexpected problem has occurred!', "error")
      })
  }

  const addAnexo = (anexo) => {
    setAnexos([...anexos, anexo])
  }

  const removeAnexo = (id) => {
    setAnexos(
      anexos.filter(a =>
        a.arquivo !== id
      )
    );
  }

  const mascaraTelefone = value => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '+$1 $2')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1')
  }

  return (
    <div >
      <Navbar lang={'en'} />
      <main className='flex mt-40 flex-col '>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
          <div className='flex justify-between mb-8'>
            <h1 className='flex text-primary items-center text-3xl gap-4 font-semibold'><FaPencilAlt />MAKE REPORT</h1>
            <a className='flex items-center text-base text-secondary gap-2 font-semibold' href="/en/home">
              <FaArrowLeft />
              <span className='hidden lg:block'>BACK TO</span>
            </a>
          </div>
          <hr className='border-background mb-8' />
          <div className='text-secondary flex flex-col gap-4 text-lg'>
            <p>Please describe the situation. When making your report, observe the points below so that our communication is as complete and detailed as possible, in this way it will contribute to us being successful in the investigation.</p>
            <p>So be sure to include in your report description if possible:</p>
            <ul className='list-disc ml-8'>
              <li><b>what:</b> describe the situation or fact you want to report;</li>
              <li><b>Who:</b> name or “nickname” of those involved (people, companies, witnesses);</li>
              <li><b>When:</b>  exact or approximate date on which the fact/situation occurred, occurs or will occur;</li>
              <li><b>Where:</b> location, sector, area, department and unit of the notified situation;</li>
              <li><b>How Much:</b> if possible and have information on quantity, values, volumes, etc;</li>
              <li><b>Evidences:</b> if they exist and where they can be found.</li>
            </ul>
            <p>To track the progress of your report, you can use the protocol provided after submitting your report.</p>
            <p>We appreciate your initiative and trust.</p>
          </div>
        </section>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto mt-8 mb-8' >
          <div className='flex flex-col lg:flex-row gap-8'>
            <button
              style={{ backgroundColor: showUserForm && '#0C4187', color: showUserForm && '#fff' }}
              onClick={() => handleUserForm()}
              className='p-8 border border-background shadow-md rounded-md text-xl font-semibold'
            >
              Yes, I want to identify myself
            </button>
            <button
              style={{ backgroundColor: showAnonForm && '#0C4187', color: showAnonForm && '#fff' }}
              onClick={() => handleShowForm()}
              className='p-8 border border-background shadow-md rounded-md text-xl font-semibold'
            >
              No, I wish to remain anonymous
            </button>
          </div>
          <div>
            <form onSubmit={handleSubmit}>
              {showUserForm &&
                <div className='mt-8'>
                  <h1 className='text-primary text-xl font-semibold'>YOUR DATA</h1>
                  <h3 className='text-secondary text-lg font-semibold'>FILL IN YOUR PERSONAL INFORMATION</h3>
                  <div className='bg-background p-8 flex flex-col gap-8'>
                    <label htmlFor="name" className='flex flex-col text-xl text-secondary'>Name:
                      <input className='text-base font-semibold rounded-md outline-primary p-2' type="text" id='name' placeholder='Name' value={form.nome} onChange={e => handleChangeInput(e.target.value, 'nome')} />
                    </label>
                    <div className='flex flex-col lg:flex-row w-full gap-8'>
                      <label htmlFor="email" className='flex flex-col text-xl text-secondary w-full'>E-mail:
                        <input className='text-base font-semibold rounded-md outline-primary p-2' type="email" id='email' placeholder='E-mail' value={form.email} onChange={e => handleChangeInput(e.target.value, 'email')} />
                      </label>
                      <label htmlFor="telefone" className='flex flex-col text-xl text-secondary w-full'>Phone:
                        <input className='text-base font-semibold rounded-md outline-primary p-2' type="text" id='telefone' placeholder='Phone' value={form.telefone} onChange={e => handleChangeInput(mascaraTelefone(e.target.value), 'telefone')} />
                      </label>
                    </div>
                  </div>
                </div>
              }
              {showForm &&
                <div className='mt-8'>
                  <h1 className='text-primary text-xl font-semibold'>REASONS FOR CONTACT</h1>
                  <h3 className='text-secondary text-lg font-semibold'>REASON FOR THE REPORT</h3>
                  <div className='bg-background p-8 flex flex-col gap-8'>
                    <select
                      name="motivo"
                      id="motivo"
                      required
                      value={form.motivo}
                      onChange={e => handleChangeInput(e.target.value, 'motivo')}
                      className='font-semibold bg-white rounded-md border-0 bg-transparent p-4 lg:w-1/2 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm'
                    >
                      <option hidden value="">SELECT</option>
                      <option value="elogio">Compliment</option>
                      <option value="sugestoes">Suggestions</option>
                      <option value="duvidas">Doubts</option>
                      <option value="solicitacoes">Requests</option>
                      <option value="denuncia">Complaint</option>
                      <option value="reclamacao">Protest</option>
                    </select>
                    <label className='flex flex-col text-xl text-secondary font-semibold' htmlFor="relato">
                      Detail your story
                      <textarea
                        required
                        name="relato"
                        id="relato"
                        rows="5"
                        value={form.relato} onChange={e => handleChangeInput(e.target.value, 'relato')}
                        className='rounded-md p-1 focus:ring-1 focus:ring-primary focus:outline-primary'
                      ></textarea>
                    </label>
                    <div className="row">
                      <label className='flex flex-col lg:flex-row text-secondary font-semibold justify-between lg:items-center' htmlFor="protocolo">
                        If this report is related to another, insert the previous protocol here:
                        <input className='lg:w-1/2 p-4 rounded-md outline-primary' type="text" id='protocolo' value={form.protocolo} onChange={e => handleChangeInput(e.target.value, 'protocolo')} />
                      </label>
                    </div>
                    <div className='text-secondary' >
                      <div>
                        <p><b>If you have a screen image, photo, that could contribute to your report, please send it to us.:</b></p>
                        <p>* Available extensions: jpg,jpeg,png</p>
                        <p>** Max file size 5MB</p>
                      </div>
                    </div>
                    <div className='flex flex-col gap-2'>
                      <span className='font-semibold text-primary'>Anexos:</span>
                      {
                        anexos.map((anexo, i) => (
                          <div className='flex items-center gap-3' key={i}>
                            <span className='font-semibold text-primary'>
                              {anexo.nomeArquivo}
                            </span>
                            <span className='hover:cursor-pointer text-warning' onClick={() => removeAnexo(anexo.arquivo)}><FaXmark /></span>
                          </div>
                        ))
                      }
                      <InputFile name={anexos.length + 1} change={addAnexo} label={`Send file`} />
                    </div>
                  </div>
                  <div className='flex justify-end'>
                    <input type="submit" value="SEND" className='px-8 py-4 uppercase text-lg bg-secondary rounded-md mt-8 text-background font-semibold hover:bg-primary hover:text-white hover:cursor-pointer' />
                  </div>
                </div>
              }
            </form>
          </div>
        </section >
      </main >
      <Footer />
    </div >
  )
};
